import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Avatar,
	Checkbox,
	TextField
} from '@material-ui/core'

import { updatePet } from '../../../actions/pets/pets.actions'
import { updatePetInventory } from '../../../actions/pets/pets.actions'

import { useDispatch } from 'react-redux'
import { isEqual } from 'lodash'

import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { DeletableChip } from '../../Misc/DeletableChip'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	},
	textField: {
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: '100%',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100%'
		}
	}
}))

const EditInventoryDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [selectedItems, setSelectedItems] = useState([])
	const [initialItems, setInitialItems] = useState([])
	const [deletedItems, setDeletedItems] = useState([])

	let { isShown, setIsShown, visit, pet } = props

	useEffect(() => {
		if (visit && pet && pet.inventory) {
			setInitialItems(pet.inventory)
		}
	}, [visit, pet, isShown])

	useEffect(() => {
		if (initialItems) {
			setSelectedItems(initialItems)
		}
	}, [initialItems])

	//   const saveFoodSchedule = () => {
	//     let updates = {
	//       visit_id: visit._id,
	//       pet_id: pet._id,
	//       mealTimes: selectedTimes,
	//     };

	//     if (visit.type === "boarding")
	//       dispatch(updatePet(pet._id, { food_schedule: selectedTimes }));
	//     else dispatch(updateMealAddOns(updates));
	//   };

	const saveInventory = () => {
		let newItems = selectedItems.filter((item) => !item._id)
		let updates = {
			pet_id: pet._id,
			facility_id: visit.facility_id,
			deletedItemsIds: deletedItems.filter((item) => item),
			newItems: newItems
		}

		dispatch(updatePetInventory(updates))
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 16
				}}>
				EDIT INVENTORY
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					Start typing items. Hit tab, comma, or return to continue to add multiple items. Hit
					backspace/delete to remove an item.
				</Typography>

				<div className={classes.textField}>
					<Autocomplete
						multiple
						disableCloseOnSelect
						size="small"
						options={[]}
						freeSolo
						value={selectedItems.map((item) => item.name)}
						onClose={(e) => {
							e.target.value = ''
						}}
						renderTags={(selected) =>
							selected.map((value) => (
								<DeletableChip
									key={value}
									label={value}
									{...{
										onDelete: () => {
											setSelectedItems(selectedItems.filter((item) => item.name != value))
											setDeletedItems([
												...deletedItems,
												selectedItems.filter((item) => item.name == value)[0]._id
											])
										}
									}}
								/>
							))
						}
						renderInput={(params) => (
							<TextField
								{...params}
								fullWidth
								variant="filled"
								label="Inventory"
								onKeyDown={(e) => {
									if (e.key === 'Tab' || e.key === 'Enter' || e.key === ',') {
										e.preventDefault()
										e.stopPropagation()
										setSelectedItems([
											...selectedItems,
											{
												name: e.target.value,
												pet_id: pet._id,
												facility_id: visit.facility_id
											}
										])
									} else return true
								}}
							/>
						)}
					/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					disabled={isEqual(initialItems.sort(), selectedItems.sort())}
					onClick={() => {
						saveInventory()
						setIsShown(false)
					}}
					color="secondary">
					Save
				</Button>

				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditInventoryDialog
